import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@antimatterhq/ui/components/dropdownMenu';
import { Text } from '@antimatterhq/ui/components/typography';

interface QueryResultsDrawerContextMenuProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  position: { x: number; y: number };
  propertyKey?: string | null;
  selectedText?: string;
  onFilterByKey?: () => void;
  onFilterBySelection?: () => void;
  onCopyValue?: () => void;
  onRemoveColumn?: () => void;
}

export const QueryResultsDrawerContextMenu: React.FC<
  QueryResultsDrawerContextMenuProps
> = ({
  open,
  onOpenChange,
  position,
  propertyKey,
  selectedText,
  onFilterByKey,
  onFilterBySelection,
  onCopyValue,
  onRemoveColumn,
}) => {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <div
          style={{
            position: 'fixed',
            left: position.x,
            top: position.y,
            width: 1,
            height: 1,
          }}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        sideOffset={0}
        className="z-query-dropdown-menu min-w-[200px]"
      >
        {propertyKey && (
          <>
            {onFilterByKey && (
              <DropdownMenuItem onClick={onFilterByKey}>
                <Text>
                  Filter by{' '}
                  <span className="font-mono text-blue-600 dark:text-blue-400">
                    {propertyKey}
                  </span>
                </Text>
              </DropdownMenuItem>
            )}
            {onRemoveColumn && (
              <DropdownMenuItem onClick={onRemoveColumn}>
                <Text>
                  Remove column{' '}
                  <span className="font-mono text-red-600 dark:text-red-400">
                    {propertyKey}
                  </span>
                </Text>
              </DropdownMenuItem>
            )}
          </>
        )}
        {selectedText && (
          <>
            {onFilterBySelection && (
              <DropdownMenuItem onClick={onFilterBySelection}>
                <Text>
                  Filter by{' '}
                  <span className="font-mono text-green-600 dark:text-green-400">
                    &quot;{selectedText}&quot;
                  </span>
                </Text>
              </DropdownMenuItem>
            )}
            {onCopyValue && (
              <DropdownMenuItem onClick={onCopyValue}>
                <Text>Copy value</Text>
              </DropdownMenuItem>
            )}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
